// VEPC Gestao - Central Administrativa: Tela de Operadores e Auditoria
import { api } from '../api.js';
import { escapeHtml } from '../utils.js';

export async function renderOperadores() {
  const container = document.createElement('div');
  container.className = 'view-content';

  container.innerHTML = `
    <div class="view-header">
      <div class="view-title-group">
        <h2>Operadores Centrais & Trilha de Auditoria</h2>
        <p>Controle de perfis de acesso da VEPC e registro imutável de todas as ações administrativas.</p>
      </div>
    </div>

    <!-- Seção de Auditoria Imutável -->
    <div class="card-panel">
      <div class="panel-header">
        <span class="panel-title">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
          Trilha de Auditoria Imutável (Append-Only)
        </span>
        <button class="btn btn-secondary btn-sm" id="btn-atualizar-aud">Atualizar Trilha</button>
      </div>
      <div class="panel-body" style="padding: 0;">
        <div class="table-responsive">
          <table class="data-table" style="font-size: 12.5px;">
            <thead>
              <tr>
                <th>Data/Hora</th>
                <th>Operador</th>
                <th>Papel</th>
                <th>Ação Executada</th>
                <th>Entidade</th>
                <th>Detalhes / Alterações</th>
              </tr>
            </thead>
            <tbody id="corpo-auditoria">
              <tr><td colspan="6" style="text-align: center; padding: 30px;">Carregando trilha de auditoria...</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  `;

  const corpoAuditoria = container.querySelector('#corpo-auditoria');

  async function carregarAuditoria() {
    try {
      const data = await api.getAuditoria('?limit=50');
      const registros = data.auditoria || [];

      if (registros.length === 0) {
        corpoAuditoria.innerHTML = `<tr><td colspan="6" style="text-align: center; padding: 30px; color: var(--vepc-text-muted);">Nenhum registro de auditoria encontrado.</td></tr>`;
        return;
      }

      corpoAuditoria.innerHTML = registros.map(a => {
        let antes = null;
        let depois = null;
        try { if (a.antes_json) antes = JSON.parse(a.antes_json); } catch (e) {}
        try { if (a.depois_json) depois = JSON.parse(a.depois_json); } catch (e) {}

        return `
          <tr>
            <td style="font-family: var(--font-mono); font-size: 11.5px; color: var(--vepc-text-muted);">
              ${new Date(a.criado_em).toLocaleString('pt-BR')}
            </td>
            <td><strong>${escapeHtml(a.operador_nome)}</strong></td>
            <td><span class="badge badge-avaliacao" style="font-size: 10px;">${escapeHtml(a.papel)}</span></td>
            <td><strong style="color: var(--vepc-azul-institucional); font-size: 12px;">${escapeHtml(a.acao)}</strong></td>
            <td><code style="font-family: var(--font-mono); font-size: 11px;">${escapeHtml(a.entidade)} ${a.entidade_id ? '#' + escapeHtml(a.entidade_id.slice(-8)) : ''}</code></td>
            <td style="max-width: 380px;">
              ${depois ? `<div style="font-family: var(--font-mono); font-size: 11px; background: #F8FAFD; padding: 4px 8px; border-radius: var(--radius-sm); border: 1px solid var(--vepc-border); overflow-x: auto;">${escapeHtml(JSON.stringify(depois))}</div>` : '—'}
            </td>
          </tr>
        `;
      }).join('');
    } catch (err) {
      corpoAuditoria.innerHTML = `<tr><td colspan="6" style="color: var(--vepc-danger); padding: 20px;">Erro ao carregar auditoria: ${err.message}</td></tr>`;
    }
  }

  container.querySelector('#btn-atualizar-aud').onclick = carregarAuditoria;

  carregarAuditoria();
  return container;
}
